// extracted by mini-css-extract-plugin
module.exports = {"feather":"footer-module--feather--CT7cv","footer":"footer-module--footer--R2bpz","footerBottom":"footer-module--footer-bottom--1SKaI"};